module.exports = __webpack_public_path__ + "img/sec4_2.78dbc786.png";